import type { ReactNode } from 'react'
import { useUserRole } from '../hooks/useUserRole'

export function FacilitatorGuard({ children, fallback }: { children: ReactNode; fallback?: ReactNode }) {
  const { isFacilitator, loading } = useUserRole()

  if (loading) {
    return <div className="loading">Loading…</div>
  }

  if (!isFacilitator) {
    return fallback || <div className="unauthorized">Facilitator access only.</div>
  }

  return <>{children}</>
}
